import React from "react";
type CtaButtonProps = {
  label?: string;
  href?: string;
  caption?: string;
};
export function CtaButton({
  label = "Get your plans now!",
  href = "https://woodworking-ready.impultienda.ar/checkout",
  caption
}: CtaButtonProps) {
  return <div className="flex flex-col items-center gap-2" data-id="element-48" data-mp="hl6vbv8r4cc8">
      <a href={href} className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-brand px-8 py-3 font-heading text-sm font-bold uppercase tracking-wide text-white shadow-md transition-[background-color,transform] duration-150 ease-out hover:bg-brand-dark active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-49" data-mp="ck9crhjtxga7">
        {label}
      </a>
      {caption && <p className="text-xs text-ink-muted" data-id="element-50" data-mp="vbshptxez4ev">{caption}</p>}
    </div>;
}